import type { SVGProps } from 'react';
const DawnFlagHN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-HN_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-HN_svg__a)">
      <path fill="#0884E6" d="M0 5.333h22V0H0zM0 16h22v-5.333H0z" />
      <path
        fill="#0E88E9"
        d="m11 8.533-.741.221.217-.754-.217-.754.74.22.742-.22-.217.754.217.754zM15.19 7.467l-.74.22.216-.754-.217-.754.741.221.741-.22-.217.753.217.755zM15.19 9.6l-.74.22.216-.753-.217-.755.741.221.741-.22-.217.754.217.754zM6.81 9.6l-.741.22.217-.753-.217-.755.74.221.741-.22-.217.754.217.754zM6.81 7.467l-.741.22.217-.754-.217-.754.74.221.741-.22-.217.753.217.755z"
      />
    </g>
  </svg>
);
export default DawnFlagHN;
